import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Required } from 'jbc-front/components/presenters/form/Label';
import { Input } from 'jbc-front/components/presenters/form/Input';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

export const Title: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <Panel>
      <Headding>
        報告書の名称
        <Spacer direction="x" size={8} />
        <Required />
      </Headding>
      <Item>
        <Input {...register('title')} />
        {errors.title?.message && <ErrorMessage>{errors.title.message}</ErrorMessage>}
      </Item>
    </Panel>
  );
};
